(() => {
  if (window.__sfBrandInit) return;
  window.__sfBrandInit = true;

  const header = document.querySelector("[data-header]");
  const veil = document.querySelector("[data-veil]");
  const menu = document.querySelector("[data-menu]");
  const menuBtn = document.querySelector("[data-menu-toggle]");

  const onScroll = () => {
    if (!header) return;
    // メニューを開いている間は白背景で固定したいので、触らない
    if (!header.classList.contains("is-menu-open")) {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    }
  };

  const closeMenu = () => {
    if (!header || !menu) return;
    header.classList.remove("is-menu-open");
    menu.hidden = true;
    if (menuBtn) menuBtn.setAttribute("aria-expanded", "false");
    if (veil) veil.hidden = true;
    onScroll();
  };

  const openMenu = () => {
    if (!header || !menu) return;
    header.classList.add("is-menu-open");
    header.classList.remove("is-scrolled");
    menu.hidden = false;
    if (menuBtn) menuBtn.setAttribute("aria-expanded", "true");
    if (veil) veil.hidden = false;
  };

  if (menuBtn) {
    menuBtn.addEventListener("click", () => {
      if (header.classList.contains("is-menu-open")) closeMenu();
      else openMenu();
    });
  }

  if (header) {
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  if (veil) veil.addEventListener("click", closeMenu);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeMenu();
  });

  // 魚(chase)を横切らせるアニメーションは snippets/sf-header.liquid の
  // インラインスクリプトが一本化して管理している。ここで重複して動かすと
  // 2つのタイマーが同じ要素を取り合って速度がバラつくため、あえて何もしない。

  /* ------------------------------------------------------------------
     ヒーロースライダー
     横スワイプはブラウザ標準の scroll-snap に任せ、JS は
     「自動送り」「無限ループ」「点と矢印」だけを担当する。
     ------------------------------------------------------------------ */
  const initHeroSlider = () => {
    const slider = document.querySelector("[data-hero-slider]");
    if (!slider || slider.dataset.heroReady === "1") return;

    const slides = [...slider.querySelectorAll("[data-hero-slide]")];
    const dotsBox = document.querySelector("[data-hero-dots]");
    const prevBtn = document.querySelector("[data-hero-prev]");
    const nextBtn = document.querySelector("[data-hero-next]");
    const total = slides.length;

    // 1枚しかないなら、ただの静止ヒーローとして何もしない
    if (total < 2) return;
    slider.dataset.heroReady = "1";

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const delay = parseInt(slider.dataset.autoplay || "4000", 10);

    // 末尾に1枚目の複製を足す。最後まで送ったあと、見た目が同じこの複製の上で
    // 先頭へ瞬間移動させることで、巻き戻しを見せずに一周させる。
    const clone = slides[0].cloneNode(true);
    clone.setAttribute("data-hero-clone", "");
    clone.setAttribute("aria-hidden", "true");
    clone.querySelectorAll("video").forEach((video) => {
      video.muted = true;
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
    });
    slider.appendChild(clone);

    const slideWidth = () => slider.clientWidth || 1;
    const currentIndex = () => Math.round(slider.scrollLeft / slideWidth());

    const goTo = (index, smooth) => {
      slider.scrollTo({
        left: index * slideWidth(),
        behavior: smooth && !reducedMotion.matches ? "smooth" : "auto",
      });
    };

    // 端では、見た目が同じ位置へ先に瞬間移動してから動かす。
    // こうすると往復の巻き戻しが見えず、端でも押した瞬間に反応する。
    const advance = () => {
      const i = currentIndex();
      if (i < total) {
        goTo(i + 1, true);
        return;
      }
      goTo(0, false);
      requestAnimationFrame(() => goTo(1, true));
    };

    const retreat = () => {
      const i = currentIndex();
      if (i > 0) {
        goTo(i - 1, true);
        return;
      }
      goTo(total, false);
      requestAnimationFrame(() => goTo(total - 1, true));
    };

    // 点
    const dots = [];
    if (dotsBox) {
      slides.forEach((_, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "hero-dot";
        dot.setAttribute("role", "tab");
        dot.setAttribute("aria-label", i + 1 + "枚目のスライド");
        dot.addEventListener("click", () => {
          restartAutoplay();
          goTo(i, true);
        });
        dotsBox.appendChild(dot);
        dots.push(dot);
      });
    }

    const paintDots = () => {
      const active = currentIndex() % total;
      dots.forEach((dot, i) => {
        const on = i === active;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
      });
    };

    // 矢印
    if (prevBtn && nextBtn) {
      prevBtn.hidden = false;
      nextBtn.hidden = false;
      prevBtn.addEventListener("click", () => {
        restartAutoplay();
        retreat();
      });
      nextBtn.addEventListener("click", () => {
        restartAutoplay();
        advance();
      });
    }

    // 停止位置が複製だったら、見た目そのままで先頭へ戻す
    const onSettle = () => {
      if (currentIndex() >= total) goTo(0, false);
      paintDots();
    };

    if ("onscrollend" in window) {
      slider.addEventListener("scrollend", onSettle);
    } else {
      let settleTimer = 0;
      slider.addEventListener(
        "scroll",
        () => {
          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(onSettle, 120);
        },
        { passive: true }
      );
    }
    slider.addEventListener("scroll", paintDots, { passive: true });

    // 自動送り
    let timer = 0;
    let held = false; // 指やマウスで触っている最中か

    const stopAutoplay = () => {
      window.clearInterval(timer);
      timer = 0;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (delay <= 0 || reducedMotion.matches) return;
      timer = window.setInterval(() => {
        if (held || document.hidden) return;
        advance();
      }, delay);
    };

    // 操作した直後にすぐ切り替わると鬱陶しいので、間隔を測り直す
    const restartAutoplay = () => startAutoplay();

    // マウスを乗せている間と、触っている間は止める
    slider.addEventListener("pointerenter", () => {
      held = true;
    });
    slider.addEventListener("pointerleave", () => {
      held = false;
      restartAutoplay();
    });
    slider.addEventListener("pointerdown", () => {
      held = true;
    });
    window.addEventListener("pointerup", () => {
      if (!held) return;
      held = false;
      restartAutoplay();
    });
    slider.addEventListener("touchstart", () => {
      held = true;
    }, { passive: true });
    slider.addEventListener("touchend", () => {
      held = false;
      restartAutoplay();
    }, { passive: true });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stopAutoplay();
      else restartAutoplay();
    });
    reducedMotion.addEventListener("change", restartAutoplay);

    // 画面幅が変わると1枚の幅も変わるので、現在位置に置き直す
    let resizeTimer = 0;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      const index = currentIndex();
      resizeTimer = window.setTimeout(() => goTo(Math.min(index, total - 1), false), 150);
    });

    paintDots();
    startAutoplay();
  };

  /* ------------------------------------------------------------------
     横スライドの共通処理（STORY / Your OutFit などで使い回す）
     [data-rail] の中に [data-rail-track] と前後ボタンを置けば動く。
     送りはカード1枚ぶん。端に着いたら、その向きの矢印を消す。
     ------------------------------------------------------------------ */
  const initRails = () => {
    document.querySelectorAll("[data-rail]").forEach((wrap) => {
      if (wrap.dataset.railReady === "1") return;

      const track = wrap.querySelector("[data-rail-track]");
      const prev = wrap.querySelector("[data-rail-prev]");
      const next = wrap.querySelector("[data-rail-next]");
      const card = track && track.firstElementChild;
      if (!track || !prev || !next || !card) return;
      wrap.dataset.railReady = "1";

      const step = () => {
        const gap = parseFloat(getComputedStyle(track).columnGap || "0") || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const paint = () => {
        const max = track.scrollWidth - track.clientWidth;
        // 1枚も隠れていない（全部見えている）なら矢印は不要
        const needed = max > 4;
        prev.hidden = !needed || track.scrollLeft <= 4;
        next.hidden = !needed || track.scrollLeft >= max - 4;
      };

      prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
      next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
      track.addEventListener("scroll", paint, { passive: true });
      window.addEventListener("resize", paint);
      paint();
    });
  };

  /* ------------------------------------------------------------------
     OUTFIT ギャラリーの拡大表示
     押された1枚を上に大きく出し、その下に残りを並べる（Pinterest 方式）。
     どの写真かは URL の ?photo=ファイル名 で受け取る。
     ------------------------------------------------------------------ */
  const initOutfitDetail = () => {
    const detail = document.querySelector("[data-outfit-detail]");
    const grid = document.querySelector("[data-outfit-grid]");
    if (!detail || !grid) return;

    const tiles = [...grid.querySelectorAll(".outfit-tile")];
    if (!tiles.length) return;

    // 「この写真の商品」。写真1枚につき最大3つ。
    //
    // 名前・値段・売り切れの判定は Liquid 側で作り終えていて、
    // 写真ごとに template として仕込んである（画面には出ていない）。
    // ここでは、それを写してカートの動きを付けるだけ。
    // こうしておくと、商品が1つでも3つでもこの処理は変わらない。
    const buildShop = (tile) => {
      const rows = tile.querySelector("template[data-shop-rows]");
      if (!rows) return null;

      const box = document.createElement("div");
      box.className = "outfit-shop";
      box.appendChild(rows.content.cloneNode(true));

      // 商品が1つも入っていなければ、囲いごと出さない。
      const buttons = [...box.querySelectorAll(".outfit-shop-add")];
      if (!buttons.length) return null;

      buttons.forEach((btn) => {
        const variant = btn.dataset.variant;
        if (!variant) btn.disabled = true;

        btn.addEventListener("click", () => {
          if (btn.disabled) return;
          const original = btn.textContent;
          btn.disabled = true;
          btn.textContent = "入れています…";
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }),
          })
            .then((r) => {
              if (!r.ok) throw new Error("add failed");
              btn.textContent = "カートに入れました";
              btn.classList.add("is-done");
            })
            .catch(() => {
              btn.textContent = "入れられませんでした";
              btn.disabled = false;
            })
            .then(() => {
              window.setTimeout(() => {
                if (!btn.classList.contains("is-done")) btn.textContent = original;
              }, 2400);
            });
        });
      });

      return box;
    };

    // 同じアイテムを着ている「ほかの写真」を集める。
    // 商品カードではなく着こなしを見せたいので、並べるのは写真。
    const sameItemTiles = (tile) => {
      const id = tile.dataset.productId;
      if (!id) return [];
      return tiles.filter((t) => t !== tile && t.dataset.productId === id);
    };

    // 近しいアイテムの写真も足す（同じ服の写真が少ないとき用）。
    // Shopify の関連商品から商品IDを借りて、その商品を着た写真を探す。
    const nearItemTiles = (tile, exclude) => {
      const id = tile.dataset.productId;
      if (!id) return Promise.resolve([]);
      return fetch(
        "/recommendations/products.json?product_id=" +
          encodeURIComponent(id) +
          "&limit=6&intent=related"
      )
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          const ids = ((data && data.products) || []).map((p) => String(p.id));
          if (!ids.length) return [];
          return tiles.filter(
            (t) =>
              t !== tile &&
              exclude.indexOf(t) === -1 &&
              t.dataset.productId &&
              ids.indexOf(t.dataset.productId) !== -1
          );
        })
        .catch(() => []);
    };

    const open = (tile) => {
      show(tile, true);
      const top = detail.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    };

    const show = (tile, updateUrl) => {
      if (!tile) return;
      const full = tile.dataset.full || "";
      const name = tile.dataset.name || "";
      const place = tile.dataset.place || "";
      const link = tile.dataset.link || "";

      detail.innerHTML = "";

      const figure = document.createElement("figure");
      figure.className = "outfit-detail-figure";

      const img = document.createElement("img");
      img.className = "outfit-detail-img";
      img.src = full;
      img.alt = name;
      figure.appendChild(img);

      const body = document.createElement("div");
      body.className = "outfit-detail-body";

      if (name || place || link) {
        const cap = document.createElement("figcaption");
        cap.className = "outfit-detail-meta";
        if (name) {
          const n = document.createElement("span");
          n.className = "outfit-detail-name";
          n.textContent = name;
          cap.appendChild(n);
        }
        if (place) {
          const p = document.createElement("span");
          p.className = "outfit-detail-place";
          p.textContent = place;
          cap.appendChild(p);
        }
        if (link) {
          const a = document.createElement("a");
          a.className = "outfit-detail-link";
          a.href = link;
          a.target = "_blank";
          a.rel = "noopener";
          a.textContent = "投稿を見る";
          cap.appendChild(a);
        }
        body.appendChild(cap);
      }

      // 着ている商品があれば、カート導線を足す。
      // 紐づけていない写真では何も出さない（余計な表示を増やさない）。
      const shop = buildShop(tile);
      if (shop) body.appendChild(shop);
      figure.appendChild(body);

      detail.appendChild(figure);
      detail.hidden = false;

      // 一覧は1つにまとめる。見出しで区切らず、
      // 同じアイテムを着ている写真を前のほうへ寄せるだけにする。
      const reorder = (front) => {
        const rest = tiles.filter((t) => t !== tile && front.indexOf(t) === -1);
        front.concat(rest).forEach((t) => grid.appendChild(t));
        tiles.forEach((t) => {
          t.hidden = t === tile;
        });
      };

      const same = sameItemTiles(tile);
      reorder(same);

      // 同じ服の写真が少ないときは、近しいアイテムの写真も前へ寄せる
      if (tile.dataset.productId && same.length < 3) {
        nearItemTiles(tile, same).then((near) => {
          if (near.length) reorder(same.concat(near));
        });
      }

      if (updateUrl && window.history && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("photo", tile.dataset.photo || "");
        history.replaceState(null, "", url);
      }
    };

    // 一覧の写真を押したら、その場で上の拡大表示を差し替える
    tiles.forEach((tile) => {
      tile.addEventListener("click", (event) => {
        // 外部リンクの実リンクを踏んだときは邪魔しない
        if (event.target.closest("a")) return;
        show(tile, true);
        const top = detail.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      });
      tile.style.cursor = "zoom-in";
    });

    // 開いた直後：URL で指定された1枚があれば出す
    const wanted = new URLSearchParams(window.location.search).get("photo");
    if (!wanted) return;
    const match = tiles.find((t) => t.dataset.photo === wanted);
    if (match) show(match, false);
  };

  // サイト下部の大きな文字を、画面の幅ぴったりに収める。
  // vw で決め打ちにすると、書体が変わったときや
  // 管理画面で文字数の違う言葉に差し替えたときに溢れる。
  // 一度 100px で描いて実際の幅を測り、そこから逆算する。
  const fitWordmark = () => {
    const el = document.querySelector("[data-wordmark]");
    if (!el || !el.textContent.trim()) return;
    const cs = getComputedStyle(el);
    const avail =
      el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (avail <= 0) return;
    el.style.fontSize = "100px";
    const range = document.createRange();
    // 測るのは中の span ではなく、その中の「文字そのもの」。
    // span は display:block なので、span を測ると
    // 文字の幅ではなく親と同じ幅が返ってきてしまう。
    range.selectNodeContents(el.querySelector(".sf-footer-wordmark-inner") || el);
    const natural = range.getBoundingClientRect().width;
    if (!natural) {
      el.style.removeProperty("font-size");
      return;
    }
    const size = (100 * avail) / natural;
    el.style.fontSize = size.toFixed(2) + "px";

    // 縦に伸ばすと、字は下端を軸に上へはみ出す。
    // そのぶんの高さを上の余白として空けておかないと、
    // 上にある SNS の行に字が重なる。
    //
    // 伸ばし具合は画面幅で変わり（スマホは倍）、その指定は calc() なので
    // 変数をそのまま読むと計算前の文字列が返ってくる。
    // 実際に効いている倍率を、掛かっている変形から取り出す。
    let stretch = 1;
    const inner = el.querySelector(".sf-footer-wordmark-inner");
    if (inner) {
      const t = getComputedStyle(inner).transform;
      if (t && t !== "none") {
        try {
          stretch = new DOMMatrixReadOnly(t).d || 1;
        } catch (e) {
          // 変形が読めない環境では伸ばさない前提で余白ゼロにする
          stretch = 1;
        }
      }
    }
    const lineBox = size * (parseFloat(cs.lineHeight) / parseFloat(cs.fontSize) || 1);
    el.style.paddingTop = Math.max(0, lineBox * (stretch - 1)).toFixed(2) + "px";
  };

  const initWordmark = () => {
    fitWordmark();
    // Web フォントは後から届くことがあり、届いた時点で字幅が変わる
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitWordmark);
    }
    let waiting = false;
    window.addEventListener("resize", () => {
      if (waiting) return;
      waiting = true;
      requestAnimationFrame(() => {
        waiting = false;
        fitWordmark();
      });
    });
  };

  // 「指定」の一覧は details なので押せば開くが、
  // 外を押しても開いたままになる。そこだけ足す。
  const initPick = () => {
    document.addEventListener("click", (e) => {
      const open = document.querySelector("[data-pick][open]");
      if (open && !open.contains(e.target)) open.removeAttribute("open");
    });
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      const open = document.querySelector("[data-pick][open]");
      if (open) open.removeAttribute("open");
    });
  };

  // スマホには「カーソルを合わせる」が無いので、
  // 指が触れている商品を、パソコンのホバーと同じだけ大きくする。
  // 指を離せば元に戻る。触れる操作が無い端末では何もしない。
  const initTouchZoom = () => {
    if (!window.matchMedia || !matchMedia("(hover: none)").matches) return;

    const SEL =
      ".p-card, .card-wrapper, .outfit-card, .outfit-tile, .story-card";
    let held = null;

    const release = () => {
      if (!held) return;
      held.classList.remove("is-touch");
      held = null;
    };

    document.addEventListener(
      "touchstart",
      (e) => {
        const t = e.touches[0];
        if (!t) return;
        // 指の真下にある要素から、いちばん近い商品の枠を探す
        const under = document.elementFromPoint(t.clientX, t.clientY);
        const card = under && under.closest && under.closest(SEL);
        release();
        if (!card) return;
        held = card;
        card.classList.add("is-touch");
      },
      { passive: true }
    );

    // 指を離したときだけでなく、通知などで操作が取り消された時も戻す
    ["touchend", "touchcancel"].forEach((ev) => {
      document.addEventListener(ev, release, { passive: true });
    });
  };

  // 魚が泳いでいる間、まわりの景色を歪ませる。
  // 群れ全体をひとまとめに歪ませると範囲が大きすぎたので、
  // 魚1匹につき1つ、その魚の大きさを基準にした歪みを付ける。
  const initWake = () => {
    const chase = document.querySelector("[data-chase]");
    if (!chase) return;
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // 指で触る端末（スマホ・タブレット）では動かさない。
    // iPhone の Safari は backdrop-filter に SVG のフィルターを渡しても
    // 何も起きない。歪みは見えないまま計算だけが走り、
    // スクロールが引っかかる原因になっていた。
    if (window.matchMedia && matchMedia("(pointer: coarse)").matches) return;

    // 魚の何倍の範囲を歪ませるか。
    // 1.2 倍まで絞ると、範囲が狭すぎて歪みに気づけなかった。
    // 4 倍でようやく「景色が波打っている」と分かる大きさになる。
    const SPREAD = 4;
    // 画面外へ抜けたあと、水が収まるまでの時間。
    // ここが 0 だと魚が消えた瞬間に歪みも消えて、作り物に見える。
    const SETTLE_MS = 900;

    // 変位フィルター。baseFrequency が小さいほど波が大きくゆったりし、
    // 大きいほど細かくなる。ただし範囲に対して細かすぎると、
    // 波に見えず ただのザラつきになる。scale が歪みの強さ。
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "0");
    svg.setAttribute("height", "0");
    svg.setAttribute("aria-hidden", "true");
    svg.style.position = "absolute";
    svg.innerHTML =
      '<filter id="sf-warp" x="-40%" y="-40%" width="180%" height="180%" color-interpolation-filters="sRGB">' +
      '<feTurbulence type="fractalNoise" baseFrequency="0.010 0.024" numOctaves="1" seed="11" result="n"/>' +
      '<feDisplacementMap in="SourceGraphic" in2="n" scale="26" xChannelSelector="R" yChannelSelector="G"/>' +
      "</filter>";
    document.body.appendChild(svg);

    // 魚の数だけ先に用意しておき、出す・消すだけにする。
    // 泳ぐたびに作り直すと、そのぶん引っかかりが出る。
    const fish = [].slice.call(chase.querySelectorAll(".chase-prey, .chase-bass"));
    const spots = fish.map(function () {
      return null;
    });
    const sizes = fish.map(function () {
      return null;
    });
    const lenses = fish.map(function () {
      const d = document.createElement("div");
      d.className = "sf-lens";
      d.setAttribute("data-lens", "");
      d.style.display = "none";
      document.body.appendChild(d);
      return d;
    });

    // 開始時刻が 0 になることもあるので、旗は別に持つ。
    // fadeAt だけで判定すると、時刻 0 のときに毎回やり直してしまう。
    let settling = false;
    let settleFrom = 0;
    let running = false;

    const swimming = () =>
      chase.classList.contains("is-swim-ltr") ||
      chase.classList.contains("is-swim-rtl");

    // 動かすのは transform だけにする。
    // left / top / width / height を毎フレーム書き替えると、そのたびに
    // 画面の配置を計算し直すことになり、スクロールと取り合って引っかかる。
    // 大きさは1回の通過のあいだ変わらないので、変わった時だけ書く。
    const place = (lens, spot, i, scale, opacity) => {
      const w = spot.w * SPREAD;
      const h = spot.h * SPREAD;
      const had = sizes[i];
      if (!had || had.w !== w || had.h !== h) {
        lens.style.width = w + "px";
        lens.style.height = h + "px";
        sizes[i] = { w: w, h: h };
      }
      if (lens.style.display !== "block") lens.style.display = "block";
      lens.style.transform =
        "translate(" + spot.cx + "px," + spot.cy + "px) translate(-50%,-50%) scale(" + scale + ")";
      lens.style.opacity = opacity;
    };

    const hide = (i) => {
      if (lenses[i].style.display !== "none") lenses[i].style.display = "none";
      spots[i] = null;
    };

    const stop = () => {
      running = false;
    };

    const tick = (now) => {
      // 別のタブを見ている間は止める。戻ってきたら次の泳ぎで動き出す。
      if (document.hidden) {
        stop();
        return;
      }

      if (swimming()) {
        settling = false;
        // 先に全部の位置を測り、そのあとでまとめて書く。
        // 測る・書くを交互にやると、魚の数だけ配置し直しが起きる。
        const read = fish.map(function (f) {
          if (f.hasAttribute("hidden")) return null;
          const b = f.getBoundingClientRect();
          return b.width ? b : null;
        });
        for (let i = 0; i < fish.length; i++) {
          const b = read[i];
          if (!b) {
            hide(i);
            continue;
          }
          // 魚の形に沿った楕円にする。真円だと縦長の魚で余りが出る。
          spots[i] = {
            cx: b.left + b.width / 2,
            cy: b.top + b.height / 2,
            w: b.width,
            h: b.height,
          };
          place(lenses[i], spots[i], i, 1, 1);
        }
        requestAnimationFrame(tick);
        return;
      }

      // 泳ぎ終わった。魚は画面外だが、水はその場に残って収まっていく。
      // 位置は最後の一歩で止めたまま、薄くしながら少しだけ広げる。
      // 魚を追いかけ続けると、画面外に戻った魚と一緒に飛んでしまう。
      if (!settling) {
        if (!spots.some(Boolean)) {
          stop();
          return;
        }
        settling = true;
        settleFrom = now;
      }
      const t = Math.min(1, (now - settleFrom) / SETTLE_MS);
      if (t >= 1) {
        for (let i = 0; i < fish.length; i++) hide(i);
        settling = false;
        stop();
        return;
      }
      // 最初は速く、終わりはゆっくり。水が落ち着いていく動き。
      const e = 1 - Math.pow(1 - t, 2);
      for (let i = 0; i < fish.length; i++) {
        if (spots[i]) place(lenses[i], spots[i], i, 1 + e * 0.35, 1 - e);
      }
      requestAnimationFrame(tick);
    };

    const start = () => {
      if (running) return;
      running = true;
      requestAnimationFrame(tick);
    };

    // 泳ぎ始めたときだけ動かす。
    // 何も起きていない間も毎フレーム回し続けると、電池を使うだけになる。
    new MutationObserver(function () {
      if (swimming()) start();
    }).observe(chase, { attributes: true, attributeFilter: ["class"] });
    if (swimming()) start();
  };

  // 日付だけで決まる「その日の並び順」を作る。
  // 同じ日なら誰が見ても同じ順番になり、日付が変わると入れ替わる。
  // 人ごとに変えないのは、そうするとページの使い回しが効かなくなり、
  // 表示が遅くなるため。
  // 区切りは日本時間の0時。世界標準時に9時間足して日付を取り出す。
  const dayNumber = () => {
    const jst = new Date(Date.now() + 9 * 60 * 60 * 1000);
    return (
      jst.getUTCFullYear() * 10000 +
      (jst.getUTCMonth() + 1) * 100 +
      jst.getUTCDate()
    );
  };

  // 決まった種から同じ結果を出す混ぜ方。
  // Math.random と違い、種が同じなら何度やっても同じ並びになる。
  const shuffleBySeed = (list, seed) => {
    let state = seed >>> 0 || 1;
    const next = () => {
      state ^= state << 13;
      state >>>= 0;
      state ^= state >> 17;
      state ^= state << 5;
      state >>>= 0;
      return state / 4294967296;
    };
    const out = list.slice();
    for (let i = out.length - 1; i > 0; i--) {
      const j = Math.floor(next() * (i + 1));
      const tmp = out[i];
      out[i] = out[j];
      out[j] = tmp;
    }
    return out;
  };

  // ホームのギャラリー欄を、ギャラリーページから読んで並べる。
  // 写真を2か所で管理しなくて済むようにするための処理。
  // 出すのは、その日の並び順で先頭から data-count 枚。
  const initOutfitAuto = () => {
    const wrap = document.querySelector("[data-outfit-auto]");
    if (!wrap) return;
    const track = wrap.querySelector("[data-rail-track]");
    const source = wrap.getAttribute("data-source");
    const count = parseInt(wrap.getAttribute("data-count"), 10) || 6;
    if (!track || !source) return;

    fetch(source, { headers: { "X-Requested-With": "fetch" } })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const all = [].slice.call(doc.querySelectorAll(".outfit-tile"));
        if (!all.length) return;
        // その日の順に混ぜてから、先頭から必要な枚数だけ取る
        const tiles = shuffleBySeed(all, dayNumber()).slice(0, count);

        tiles.forEach(function (tile) {
          const img = tile.querySelector("img");
          if (!img) return;

          const card = document.createElement("a");
          card.className = "outfit-card";
          // どの写真を開くかは画像のファイル名で受け渡す。
          // ギャラリー側がこの名前を見て、その1枚を拡大して出す。
          const key = tile.getAttribute("data-photo") || "";
          const join = source.indexOf("?") === -1 ? "?" : "&";
          card.href = source + join + "photo=" + encodeURIComponent(key);

          // 画像は作り直さず、ギャラリー側のものをそのまま持ってくる。
          // srcset ごと引き継げるので、余計な読み込みが起きない。
          const copy = img.cloneNode(true);
          copy.className = "outfit-card-img";
          copy.setAttribute("loading", "lazy");
          card.appendChild(copy);

          const name = tile.getAttribute("data-name");
          if (name) {
            const label = document.createElement("span");
            label.className = "outfit-card-name";
            label.textContent = name;
            card.appendChild(label);
          }
          track.appendChild(card);
        });

        // 中身が入ってから見せる。空の見出しだけが出るのを避ける。
        wrap.hidden = false;
        // 前後ボタンの出し入れは、中身が入ったあとで測り直す必要がある。
        initRails();
      })
      .catch(function () {
        // 読めなかったときは、この欄を出さないままにする。
      });
  };

  /* ------------------------------------------------------------------
     メジャー
     ギャラリーとストーリーを横に送った現在地を、
     0〜100cm の目盛りとして見せる。

     実物のメジャーを引き出すように、目盛りそのものが流れる。
     レールの「見えている割合」をそのまま目盛りの窓にしているので、
     0 がきっかり左端から始まり、端まで送ると 100cm が右端でぴたりと止まる。

     目立たせたいのは数字のほうなので、目盛りはすべて同じ短さにしてある。
     ------------------------------------------------------------------ */
  const initTape = () => {
    const MAX_CM = 100;

    // 数字を出す位置。5cm ごとが基本だが、
    // 10・15・20 は出さずに 11 と 17、95 は出さずに 96 を出す。
    // 本人の指定によるもので、目盛りの計算とは関係がない。
    const hasNumber = (v) => {
      if (v === 10 || v === 15 || v === 20 || v === 95) return false;
      if (v === 11 || v === 17 || v === 96) return true;
      return v % 5 === 0;
    };

    const tapes = [];

    document.querySelectorAll("[data-tape]").forEach((tape) => {
      if (tape.dataset.tapeOn === "1") return;

      // 目盛りはレールの「すぐ下」に置いてある（レールの中ではない）。
      // 中に入れると囲いが高くなり、左右の矢印が上下中央からずれてしまう。
      // そのため、祖先ではなく「ひとつ前の兄弟」を見る。
      const prev = tape.previousElementSibling;
      const wrap =
        prev && prev.matches("[data-rail]")
          ? prev
          : (tape.closest("section") || document).querySelector("[data-rail]");
      const rail = wrap && wrap.querySelector("[data-rail-track]");
      const strip = tape.querySelector("[data-tape-strip]");
      if (!rail || !strip) return;
      tape.dataset.tapeOn = "1";

      const item = { tape: tape, rail: rail, pxPerCm: 0 };

      item.sync = () => {
        if (!item.pxPerCm) return;
        const room = rail.scrollWidth - rail.clientWidth;
        const progress = room > 0 ? rail.scrollLeft / room : 0;
        // 送り始めは 0cm がきっかり左端。送り切ると 100cm がきっかり右端。
        const travel = tape.clientWidth - MAX_CM * item.pxPerCm;
        strip.style.transform = "translateX(" + travel * progress + "px)";
      };

      item.build = () => {
        // ギャラリーは中身が後から入る。空のうちは目盛りも出さない。
        if (!rail.children.length) {
          tape.hidden = true;
          return;
        }
        tape.hidden = false;

        const width = tape.clientWidth;
        if (!width) return;

        // 見えている割合が、そのまま目盛りの窓になる。
        // 送る余地が無いときは 100cm 全部を見せる。
        const shown = Math.min(1, rail.clientWidth / rail.scrollWidth);
        item.pxPerCm = width / (MAX_CM * shown);
        strip.style.width = MAX_CM * item.pxPerCm + "px";

        // 目盛りが詰まりすぎるときは 1cm 刻みをやめる
        const step = item.pxPerCm < 6 ? 5 : 1;
        let html = "";
        for (let v = 0; v <= MAX_CM; v += step) {
          const x = v * item.pxPerCm;
          html += '<span class="sf-tape-tick" style="left:' + x + 'px"></span>';
          if (hasNumber(v)) {
            // 数字は目盛りの真上に置くが、0 と 100 だけは中央に置くと
            // 画面の外へはみ出すので、内側へ寄せる。
            let shift = "";
            if (v === 0) shift = ";transform:none";
            if (v === MAX_CM) shift = ";transform:translateX(-100%)";
            html +=
              '<span class="sf-tape-num" style="left:' + x + 'px' + shift + '">' + v + "</span>";
          }
        }
        strip.innerHTML = html;
        item.sync();
      };

      // 指で送っている間も滑らかに追うため、1フレームに1回だけ動かす
      let waiting = false;
      rail.addEventListener(
        "scroll",
        () => {
          if (waiting) return;
          waiting = true;
          window.requestAnimationFrame(() => {
            waiting = false;
            item.sync();
          });
        },
        { passive: true }
      );

      tapes.push(item);
    });

    if (!tapes.length) return;

    // ストーリーはまだ記事が少なく、ギャラリーより先に終わってしまう。
    // そのままだと同じ幅の目盛りなのに進み方が左右で食い違うので、
    // 記事の後ろに空きを足して、送れる長さをギャラリーにそろえる。
    // 記事が増えれば空きは自然に縮み、ギャラリーを追い越せば 0 になる。
    const matchLength = () => {
      const from = document.querySelector(".outfit-rail[data-rail-track]");
      const to = document.querySelector(".story-rail[data-rail-track]");
      const pad = to && to.querySelector("[data-rail-pad]");
      if (!from || !to || !pad || !from.children.length) return;
      // 一度 0 に戻してから測らないと、前回の空きを足した長さで比べてしまう。
      pad.style.width = "0px";
      pad.style.width = Math.max(0, from.scrollWidth - to.scrollWidth) + "px";
    };

    const refresh = () => {
      matchLength();
      tapes.forEach((t) => t.build());
    };

    // ギャラリーの写真は後から入るので、入った時点で組み直す
    tapes.forEach((t) => {
      new MutationObserver(refresh).observe(t.rail, { childList: true });
    });
    window.addEventListener("resize", refresh);
    refresh();
  };

  initHeroSlider();
  initRails();
  initOutfitAuto();
  initOutfitDetail();
  initWordmark();
  initPick();
  initTouchZoom();
  initWake();
  initTape();
  document.addEventListener("shopify:section:load", () => {
    initHeroSlider();
    initRails();
    initOutfitDetail();
    fitWordmark();
    initTape();
  });
})();
